import { jsx as d, jsxs as I, Fragment as J } from "react/jsx-runtime";
import * as z from "react";
import { createContext as H, useState as S, useCallback as Ee, useMemo as V, useContext as D, useRef as ee, useEffect as $ } from "react";
const K = ":@", k = "#text", U = "#comment", Y = "#cdata", te = "DECLARATION_TAG", be = "TAG", M = {
  tagColor: "#d43900",
  textColor: "#333",
  attributeKeyColor: "#2a7ab0",
  attributeValueColor: "#008000",
  separatorColor: "#333",
  commentColor: "#aaa",
  cdataColor: "#1d781d",
  fontFamily: "monospace",
  lineNumberBackground: "#eee",
  lineNumberColor: "#222"
}, Te = {
  lines: {},
  push: () => {
  }
}, ne = H(Te), Ne = ({ children: e }) => {
  const [t, n] = S({}), s = Ee((r, l) => {
    n((a) => {
      var u;
      return ((u = a[r]) == null ? void 0 : u.element) === l.element ? a : { ...a, [r]: l };
    });
  }, []), i = V(() => ({ lines: t, push: s }), [t, s]);
  return /* @__PURE__ */ d(ne.Provider, { value: i, children: e });
}, se = () => D(ne), ye = {
  theme: M,
  collapsible: !1,
  indentSize: 2
}, re = H(ye), w = () => D(re);
function we(e, t) {
  return new Array(t * e + 1).join(" ");
}
function ie(e) {
  return typeof e == "string" && e.includes(`
`);
}
function Ie(e) {
  return typeof e == "string" ? !1 : e.length === 1 && k in e[0] && !ie(e[0][k]);
}
function me(e) {
  switch (e) {
    case k:
    case Y:
    case U:
      return e;
    default:
      return e.startsWith("?") ? te : be;
  }
}
function Ce(e, t) {
  const n = {};
  for (const s in e)
    s !== t && (n[s] = e[s]);
  return n;
}
function Ae(e) {
  const t = e[K], n = Ce(e, K), [[s, i]] = Object.entries(n), r = me(s);
  return { attributes: t, tagKey: s, subElements: i, type: r };
}
function ve(e, t) {
  return Object.keys(M).every((s) => e[s] === t[s]);
}
const oe = ":A-Za-z_\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", Oe = oe + "\\-.\\d\\u00B7\\u0300-\\u036F\\u203F-\\u2040", Pe = "[" + oe + "][" + Oe + "]*", xe = new RegExp("^" + Pe + "$");
function le(e, t) {
  const n = [];
  let s = t.exec(e);
  for (; s; ) {
    const i = [];
    i.startIndex = t.lastIndex - s[0].length;
    const r = s.length;
    for (let l = 0; l < r; l++)
      i.push(s[l]);
    n.push(i), s = t.exec(e);
  }
  return n;
}
const R = function(e) {
  const t = xe.exec(e);
  return !(t === null || typeof t > "u");
};
function Se(e) {
  return typeof e < "u";
}
const Ve = {
  allowBooleanAttributes: !1,
  //A tag can have attributes without any value
  unpairedTags: []
};
function ue(e, t) {
  t = Object.assign({}, Ve, t);
  const n = [];
  let s = !1, i = !1;
  e[0] === "\uFEFF" && (e = e.substr(1));
  for (let r = 0; r < e.length; r++)
    if (e[r] === "<" && e[r + 1] === "?") {
      if (r += 2, r = W(e, r), r.err)
        return r;
    } else if (e[r] === "<") {
      let l = r;
      if (r++, e[r] === "!") {
        r = G(e, r);
        continue;
      } else {
        let a = !1;
        e[r] === "/" && (a = !0, r++);
        let u = "";
        for (; r < e.length && e[r] !== ">" && e[r] !== " " && e[r] !== "	" && e[r] !== `
` && e[r] !== "\r"; r++)
          u += e[r];
        if (u = u.trim(), u[u.length - 1] === "/" && (u = u.substring(0, u.length - 1), r--), !je(u)) {
          let c;
          return u.trim().length === 0 ? c = "Invalid space after '<'." : c = "Tag '" + u + "' is an invalid name.", E("InvalidTag", c, b(e, r));
        }
        const o = ke(e, r);
        if (o === !1)
          return E("InvalidAttr", "Attributes for '" + u + "' have open quote.", b(e, r));
        let f = o.value;
        if (r = o.index, f[f.length - 1] === "/") {
          const c = r - f.length;
          f = f.substring(0, f.length - 1);
          const h = q(f, t);
          if (h === !0)
            s = !0;
          else
            return E(h.err.code, h.err.msg, b(e, c + h.err.line));
        } else if (a)
          if (o.tagClosed) {
            if (f.trim().length > 0)
              return E("InvalidTag", "Closing tag '" + u + "' can't have attributes or invalid starting.", b(e, l));
            if (n.length === 0)
              return E("InvalidTag", "Closing tag '" + u + "' has not been opened.", b(e, l));
            {
              const c = n.pop();
              if (u !== c.tagName) {
                let h = b(e, c.tagStartPos);
                return E(
                  "InvalidTag",
                  "Expected closing tag '" + c.tagName + "' (opened in line " + h.line + ", col " + h.col + ") instead of closing tag '" + u + "'.",
                  b(e, l)
                );
              }
              n.length == 0 && (i = !0);
            }
          } else
            return E("InvalidTag", "Closing tag '" + u + "' doesn't have proper closing.", b(e, r));
        else {
          const c = q(f, t);
          if (c !== !0)
            return E(c.err.code, c.err.msg, b(e, r - f.length + c.err.line));
          if (i === !0)
            return E("InvalidXml", "Multiple possible root nodes found.", b(e, r));
          t.unpairedTags.indexOf(u) !== -1 || n.push({ tagName: u, tagStartPos: l }), s = !0;
        }
        for (r++; r < e.length; r++)
          if (e[r] === "<")
            if (e[r + 1] === "!") {
              r++, r = G(e, r);
              continue;
            } else if (e[r + 1] === "?") {
              if (r = W(e, ++r), r.err)
                return r;
            } else
              break;
          else if (e[r] === "&") {
            const c = Re(e, r);
            if (c == -1)
              return E("InvalidChar", "char '&' is not expected.", b(e, r));
            r = c;
          } else if (i === !0 && !Z(e[r]))
            return E("InvalidXml", "Extra text at the end", b(e, r));
        e[r] === "<" && r--;
      }
    } else {
      if (Z(e[r]))
        continue;
      return E("InvalidChar", "char '" + e[r] + "' is not expected.", b(e, r));
    }
  if (s) {
    if (n.length == 1)
      return E("InvalidTag", "Unclosed tag '" + n[0].tagName + "'.", b(e, n[0].tagStartPos));
    if (n.length > 0)
      return E("InvalidXml", "Invalid '" + JSON.stringify(n.map((r) => r.tagName), null, 4).replace(/\r?\n/g, "") + "' found.", { line: 1, col: 1 });
  } else
    return E("InvalidXml", "Start tag expected.", 1);
  return !0;
}
function Z(e) {
  return e === " " || e === "	" || e === `
` || e === "\r";
}
function W(e, t) {
  const n = t;
  for (; t < e.length; t++)
    if (e[t] == "?" || e[t] == " ") {
      const s = e.substr(n, t - n);
      if (t > 5 && s === "xml")
        return E("InvalidXml", "XML declaration allowed only at the start of the document.", b(e, t));
      if (e[t] == "?" && e[t + 1] == ">") {
        t++;
        break;
      } else
        continue;
    }
  return t;
}
function G(e, t) {
  if (e.length > t + 5 && e[t + 1] === "-" && e[t + 2] === "-") {
    for (t += 3; t < e.length; t++)
      if (e[t] === "-" && e[t + 1] === "-" && e[t + 2] === ">") {
        t += 2;
        break;
      }
  } else if (e.length > t + 8 && e[t + 1] === "D" && e[t + 2] === "O" && e[t + 3] === "C" && e[t + 4] === "T" && e[t + 5] === "Y" && e[t + 6] === "P" && e[t + 7] === "E") {
    let n = 1;
    for (t += 8; t < e.length; t++)
      if (e[t] === "<")
        n++;
      else if (e[t] === ">" && (n--, n === 0))
        break;
  } else if (e.length > t + 9 && e[t + 1] === "[" && e[t + 2] === "C" && e[t + 3] === "D" && e[t + 4] === "A" && e[t + 5] === "T" && e[t + 6] === "A" && e[t + 7] === "[") {
    for (t += 8; t < e.length; t++)
      if (e[t] === "]" && e[t + 1] === "]" && e[t + 2] === ">") {
        t += 2;
        break;
      }
  }
  return t;
}
const $e = '"', Le = "'";
function ke(e, t) {
  let n = "", s = "", i = !1;
  for (; t < e.length; t++) {
    if (e[t] === $e || e[t] === Le)
      s === "" ? s = e[t] : s !== e[t] || (s = "");
    else if (e[t] === ">" && s === "") {
      i = !0;
      break;
    }
    n += e[t];
  }
  return s !== "" ? !1 : {
    value: n,
    index: t,
    tagClosed: i
  };
}
const Me = new RegExp(`(\\s*)([^\\s=]+)(\\s*=)?(\\s*(['"])(([\\s\\S])*?)\\5)?`, "g");
function q(e, t) {
  const n = le(e, Me), s = {};
  for (let i = 0; i < n.length; i++) {
    if (n[i][1].length === 0)
      return E("InvalidAttr", "Attribute '" + n[i][2] + "' has no space in starting.", P(n[i]));
    if (n[i][3] !== void 0 && n[i][4] === void 0)
      return E("InvalidAttr", "Attribute '" + n[i][2] + "' is without value.", P(n[i]));
    if (n[i][3] === void 0 && !t.allowBooleanAttributes)
      return E("InvalidAttr", "boolean attribute '" + n[i][2] + "' is not allowed.", P(n[i]));
    const r = n[i][2];
    if (!_e(r))
      return E("InvalidAttr", "Attribute '" + r + "' is an invalid name.", P(n[i]));
    if (!Object.prototype.hasOwnProperty.call(s, r))
      s[r] = 1;
    else
      return E("InvalidAttr", "Attribute '" + r + "' is repeated.", P(n[i]));
  }
  return !0;
}
function Fe(e, t) {
  let n = /\d/;
  for (e[t] === "x" && (t++, n = /[\da-fA-F]/); t < e.length; t++) {
    if (e[t] === ";")
      return t;
    if (!e[t].match(n))
      break;
  }
  return -1;
}
function Re(e, t) {
  if (t++, e[t] === ";")
    return -1;
  if (e[t] === "#")
    return t++, Fe(e, t);
  let n = 0;
  for (; t < e.length; t++, n++)
    if (!(e[t].match(/\w/) && n < 20)) {
      if (e[t] === ";")
        break;
      return -1;
    }
  return t;
}
function E(e, t, n) {
  return {
    err: {
      code: e,
      msg: t,
      line: n.line || n,
      col: n.col
    }
  };
}
function _e(e) {
  return R(e);
}
function je(e) {
  return R(e);
}
function b(e, t) {
  const n = e.substring(0, t).split(/\r?\n/);
  return {
    line: n.length,
    // column number is last line's length + 1, because column numbering starts at 1:
    col: n[n.length - 1].length + 1
  };
}
function P(e) {
  return e.startIndex + e[1].length;
}
const Be = {
  preserveOrder: !1,
  attributeNamePrefix: "@_",
  attributesGroupName: !1,
  textNodeName: "#text",
  ignoreAttributes: !0,
  removeNSPrefix: !1,
  // remove NS from tag name or attribute name if true
  allowBooleanAttributes: !1,
  //a tag can have attributes without any value
  //ignoreRootElement : false,
  parseTagValue: !0,
  parseAttributeValue: !1,
  trimValues: !0,
  //Trim string values of tag and attributes
  cdataPropName: !1,
  numberParseOptions: {
    hex: !0,
    leadingZeros: !0,
    eNotation: !0
  },
  tagValueProcessor: function(e, t) {
    return t;
  },
  attributeValueProcessor: function(e, t) {
    return t;
  },
  stopNodes: [],
  //nested tags will not be parsed even for errors
  alwaysCreateTextNode: !1,
  isArray: () => !1,
  commentPropName: !1,
  unpairedTags: [],
  processEntities: !0,
  htmlEntities: !1,
  ignoreDeclaration: !1,
  ignorePiTags: !1,
  transformTagName: !1,
  transformAttributeName: !1,
  updateTag: function(e, t, n) {
    return e;
  },
  // skipEmptyListItem: false
  captureMetaData: !1,
  maxNestedTags: 100,
  strictReservedNames: !0
};
function ae(e) {
  return typeof e == "boolean" ? {
    enabled: e,
    // true or false
    maxEntitySize: 1e4,
    maxExpansionDepth: 10,
    maxTotalExpansions: 1e3,
    maxExpandedLength: 1e5,
    allowedTags: null,
    tagFilter: null
  } : typeof e == "object" && e !== null ? {
    enabled: e.enabled !== !1,
    // default true if not specified
    maxEntitySize: e.maxEntitySize ?? 1e4,
    maxExpansionDepth: e.maxExpansionDepth ?? 10,
    maxTotalExpansions: e.maxTotalExpansions ?? 1e3,
    maxExpandedLength: e.maxExpandedLength ?? 1e5,
    allowedTags: e.allowedTags ?? null,
    tagFilter: e.tagFilter ?? null
  } : ae(!0);
}
const Xe = function(e) {
  const t = Object.assign({}, Be, e);
  return t.processEntities = ae(t.processEntities), t;
};
let F;
typeof Symbol != "function" ? F = "@@xmlMetadata" : F = Symbol("XML Node Metadata");
class m {
  constructor(t) {
    this.tagname = t, this.child = [], this[":@"] = /* @__PURE__ */ Object.create(null);
  }
  add(t, n) {
    t === "__proto__" && (t = "#__proto__"), this.child.push({ [t]: n });
  }
  addChild(t, n) {
    t.tagname === "__proto__" && (t.tagname = "#__proto__"), t[":@"] && Object.keys(t[":@"]).length > 0 ? this.child.push({ [t.tagname]: t.child, ":@": t[":@"] }) : this.child.push({ [t.tagname]: t.child }), n !== void 0 && (this.child[this.child.length - 1][F] = { startIndex: n });
  }
  /** symbol used for metadata */
  static getMetaDataSymbol() {
    return F;
  }
}
class Ue {
  constructor(t) {
    this.suppressValidationErr = !t, this.options = t;
  }
  readDocType(t, n) {
    const s = /* @__PURE__ */ Object.create(null);
    if (t[n + 3] === "O" && t[n + 4] === "C" && t[n + 5] === "T" && t[n + 6] === "Y" && t[n + 7] === "P" && t[n + 8] === "E") {
      n = n + 9;
      let i = 1, r = !1, l = !1, a = "";
      for (; n < t.length; n++)
        if (t[n] === "<" && !l) {
          if (r && A(t, "!ENTITY", n)) {
            n += 7;
            let u, o;
            if ([u, o, n] = this.readEntityExp(t, n + 1, this.suppressValidationErr), o.indexOf("&") === -1) {
              const f = u.replace(/[.\-+*:]/g, "\\.");
              s[u] = {
                regx: RegExp(`&${f};`, "g"),
                val: o
              };
            }
          } else if (r && A(t, "!ELEMENT", n)) {
            n += 8;
            const { index: u } = this.readElementExp(t, n + 1);
            n = u;
          } else if (r && A(t, "!ATTLIST", n))
            n += 8;
          else if (r && A(t, "!NOTATION", n)) {
            n += 9;
            const { index: u } = this.readNotationExp(t, n + 1, this.suppressValidationErr);
            n = u;
          } else if (A(t, "!--", n))
            l = !0;
          else
            throw new Error("Invalid DOCTYPE");
          i++, a = "";
        } else if (t[n] === ">") {
          if (l ? t[n - 1] === "-" && t[n - 2] === "-" && (l = !1, i--) : i--, i === 0)
            break;
        } else
          t[n] === "[" ? r = !0 : a += t[n];
      if (i !== 0)
        throw new Error("Unclosed DOCTYPE");
    } else
      throw new Error("Invalid Tag instead of DOCTYPE");
    return { entities: s, i: n };
  }
  readEntityExp(t, n) {
    n = T(t, n);
    let s = "";
    for (; n < t.length && !/\s/.test(t[n]) && t[n] !== '"' && t[n] !== "'"; )
      s += t[n], n++;
    if (x(s), n = T(t, n), !this.suppressValidationErr) {
      if (t.substring(n, n + 6).toUpperCase() === "SYSTEM")
        throw new Error("External entities are not supported");
      if (t[n] === "%")
        throw new Error("Parameter entities are not supported");
    }
    let i = "";
    if ([n, i] = this.readIdentifierVal(t, n, "entity"), this.options.enabled !== !1 && this.options.maxEntitySize && i.length > this.options.maxEntitySize)
      throw new Error(
        `Entity "${s}" size (${i.length}) exceeds maximum allowed size (${this.options.maxEntitySize})`
      );
    return n--, [s, i, n];
  }
  readNotationExp(t, n) {
    n = T(t, n);
    let s = "";
    for (; n < t.length && !/\s/.test(t[n]); )
      s += t[n], n++;
    !this.suppressValidationErr && x(s), n = T(t, n);
    const i = t.substring(n, n + 6).toUpperCase();
    if (!this.suppressValidationErr && i !== "SYSTEM" && i !== "PUBLIC")
      throw new Error(`Expected SYSTEM or PUBLIC, found "${i}"`);
    n += i.length, n = T(t, n);
    let r = null, l = null;
    if (i === "PUBLIC")
      [n, r] = this.readIdentifierVal(t, n, "publicIdentifier"), n = T(t, n), (t[n] === '"' || t[n] === "'") && ([n, l] = this.readIdentifierVal(t, n, "systemIdentifier"));
    else if (i === "SYSTEM" && ([n, l] = this.readIdentifierVal(t, n, "systemIdentifier"), !this.suppressValidationErr && !l))
      throw new Error("Missing mandatory system identifier for SYSTEM notation");
    return { notationName: s, publicIdentifier: r, systemIdentifier: l, index: --n };
  }
  readIdentifierVal(t, n, s) {
    let i = "";
    const r = t[n];
    if (r !== '"' && r !== "'")
      throw new Error(`Expected quoted string, found "${r}"`);
    for (n++; n < t.length && t[n] !== r; )
      i += t[n], n++;
    if (t[n] !== r)
      throw new Error(`Unterminated ${s} value`);
    return n++, [n, i];
  }
  readElementExp(t, n) {
    n = T(t, n);
    let s = "";
    for (; n < t.length && !/\s/.test(t[n]); )
      s += t[n], n++;
    if (!this.suppressValidationErr && !R(s))
      throw new Error(`Invalid element name: "${s}"`);
    n = T(t, n);
    let i = "";
    if (t[n] === "E" && A(t, "MPTY", n))
      n += 4;
    else if (t[n] === "A" && A(t, "NY", n))
      n += 2;
    else if (t[n] === "(") {
      for (n++; n < t.length && t[n] !== ")"; )
        i += t[n], n++;
      if (t[n] !== ")")
        throw new Error("Unterminated content model");
    } else if (!this.suppressValidationErr)
      throw new Error(`Invalid Element Expression, found "${t[n]}"`);
    return {
      elementName: s,
      contentModel: i.trim(),
      index: n
    };
  }
  readAttlistExp(t, n) {
    n = T(t, n);
    let s = "";
    for (; n < t.length && !/\s/.test(t[n]); )
      s += t[n], n++;
    x(s), n = T(t, n);
    let i = "";
    for (; n < t.length && !/\s/.test(t[n]); )
      i += t[n], n++;
    if (!x(i))
      throw new Error(`Invalid attribute name: "${i}"`);
    n = T(t, n);
    let r = "";
    if (t.substring(n, n + 8).toUpperCase() === "NOTATION") {
      if (r = "NOTATION", n += 8, n = T(t, n), t[n] !== "(")
        throw new Error(`Expected '(', found "${t[n]}"`);
      n++;
      let a = [];
      for (; n < t.length && t[n] !== ")"; ) {
        let u = "";
        for (; n < t.length && t[n] !== "|" && t[n] !== ")"; )
          u += t[n], n++;
        if (u = u.trim(), !x(u))
          throw new Error(`Invalid notation name: "${u}"`);
        a.push(u), t[n] === "|" && (n++, n = T(t, n));
      }
      if (t[n] !== ")")
        throw new Error("Unterminated list of notations");
      n++, r += " (" + a.join("|") + ")";
    } else {
      for (; n < t.length && !/\s/.test(t[n]); )
        r += t[n], n++;
      const a = ["CDATA", "ID", "IDREF", "IDREFS", "ENTITY", "ENTITIES", "NMTOKEN", "NMTOKENS"];
      if (!this.suppressValidationErr && !a.includes(r.toUpperCase()))
        throw new Error(`Invalid attribute type: "${r}"`);
    }
    n = T(t, n);
    let l = "";
    return t.substring(n, n + 8).toUpperCase() === "#REQUIRED" ? (l = "#REQUIRED", n += 8) : t.substring(n, n + 7).toUpperCase() === "#IMPLIED" ? (l = "#IMPLIED", n += 7) : [n, l] = this.readIdentifierVal(t, n, "ATTLIST"), {
      elementName: s,
      attributeName: i,
      attributeType: r,
      defaultValue: l,
      index: n
    };
  }
}
const T = (e, t) => {
  for (; t < e.length && /\s/.test(e[t]); )
    t++;
  return t;
};
function A(e, t, n) {
  for (let s = 0; s < t.length; s++)
    if (t[s] !== e[n + s + 1])
      return !1;
  return !0;
}
function x(e) {
  if (R(e))
    return e;
  throw new Error(`Invalid entity name ${e}`);
}
const Ye = /^[-+]?0x[a-fA-F0-9]+$/, ze = /^([\-\+])?(0*)([0-9]*(\.[0-9]*)?)$/, Ke = {
  hex: !0,
  // oct: false,
  leadingZeros: !0,
  decimalPoint: ".",
  eNotation: !0
  //skipLike: /regex/
};
function Ze(e, t = {}) {
  if (t = Object.assign({}, Ke, t), !e || typeof e != "string")
    return e;
  let n = e.trim();
  if (t.skipLike !== void 0 && t.skipLike.test(n))
    return e;
  if (e === "0")
    return 0;
  if (t.hex && Ye.test(n))
    return Qe(n, 16);
  if (n.includes("e") || n.includes("E"))
    return Ge(e, n, t);
  {
    const s = ze.exec(n);
    if (s) {
      const i = s[1] || "", r = s[2];
      let l = qe(s[3]);
      const a = i ? (
        // 0., -00., 000.
        e[r.length + 1] === "."
      ) : e[r.length] === ".";
      if (!t.leadingZeros && (r.length > 1 || r.length === 1 && !a))
        return e;
      {
        const u = Number(n), o = String(u);
        if (u === 0)
          return u;
        if (o.search(/[eE]/) !== -1)
          return t.eNotation ? u : e;
        if (n.indexOf(".") !== -1)
          return o === "0" || o === l || o === `${i}${l}` ? u : e;
        let f = r ? l : n;
        return r ? f === o || i + f === o ? u : e : f === o || f === i + o ? u : e;
      }
    } else
      return e;
  }
}
const We = /^([-+])?(0*)(\d*(\.\d*)?[eE][-\+]?\d+)$/;
function Ge(e, t, n) {
  if (!n.eNotation)
    return e;
  const s = t.match(We);
  if (s) {
    let i = s[1] || "";
    const r = s[3].indexOf("e") === -1 ? "E" : "e", l = s[2], a = i ? (
      // 0E.
      e[l.length + 1] === r
    ) : e[l.length] === r;
    return l.length > 1 && a ? e : l.length === 1 && (s[3].startsWith(`.${r}`) || s[3][0] === r) ? Number(t) : n.leadingZeros && !a ? (t = (s[1] || "") + s[3], Number(t)) : e;
  } else
    return e;
}
function qe(e) {
  return e && e.indexOf(".") !== -1 && (e = e.replace(/0+$/, ""), e === "." ? e = "0" : e[0] === "." ? e = "0" + e : e[e.length - 1] === "." && (e = e.substring(0, e.length - 1))), e;
}
function Qe(e, t) {
  if (parseInt)
    return parseInt(e, t);
  if (Number.parseInt)
    return Number.parseInt(e, t);
  if (window && window.parseInt)
    return window.parseInt(e, t);
  throw new Error("parseInt, Number.parseInt, window.parseInt are not supported");
}
function Je(e) {
  return typeof e == "function" ? e : Array.isArray(e) ? (t) => {
    for (const n of e)
      if (typeof n == "string" && t === n || n instanceof RegExp && n.test(t))
        return !0;
  } : () => !1;
}
class He {
  constructor(t) {
    if (this.options = t, this.currentNode = null, this.tagsNodeStack = [], this.docTypeEntities = {}, this.lastEntities = {
      apos: { regex: /&(apos|#39|#x27);/g, val: "'" },
      gt: { regex: /&(gt|#62|#x3E);/g, val: ">" },
      lt: { regex: /&(lt|#60|#x3C);/g, val: "<" },
      quot: { regex: /&(quot|#34|#x22);/g, val: '"' }
    }, this.ampEntity = { regex: /&(amp|#38|#x26);/g, val: "&" }, this.htmlEntities = {
      space: { regex: /&(nbsp|#160);/g, val: " " },
      // "lt" : { regex: /&(lt|#60);/g, val: "<" },
      // "gt" : { regex: /&(gt|#62);/g, val: ">" },
      // "amp" : { regex: /&(amp|#38);/g, val: "&" },
      // "quot" : { regex: /&(quot|#34);/g, val: "\"" },
      // "apos" : { regex: /&(apos|#39);/g, val: "'" },
      cent: { regex: /&(cent|#162);/g, val: "¢" },
      pound: { regex: /&(pound|#163);/g, val: "£" },
      yen: { regex: /&(yen|#165);/g, val: "¥" },
      euro: { regex: /&(euro|#8364);/g, val: "€" },
      copyright: { regex: /&(copy|#169);/g, val: "©" },
      reg: { regex: /&(reg|#174);/g, val: "®" },
      inr: { regex: /&(inr|#8377);/g, val: "₹" },
      num_dec: { regex: /&#([0-9]{1,7});/g, val: (n, s) => Q(s, 10, "&#") },
      num_hex: { regex: /&#x([0-9a-fA-F]{1,6});/g, val: (n, s) => Q(s, 16, "&#x") }
    }, this.addExternalEntities = De, this.parseXml = rt, this.parseTextData = et, this.resolveNameSpace = tt, this.buildAttributesMap = st, this.isItStopNode = ut, this.replaceEntitiesValue = ot, this.readStopNodeData = ct, this.saveTextToParentTag = lt, this.addChild = it, this.ignoreAttributesFn = Je(this.options.ignoreAttributes), this.entityExpansionCount = 0, this.currentExpandedLength = 0, this.options.stopNodes && this.options.stopNodes.length > 0) {
      this.stopNodesExact = /* @__PURE__ */ new Set(), this.stopNodesWildcard = /* @__PURE__ */ new Set();
      for (let n = 0; n < this.options.stopNodes.length; n++) {
        const s = this.options.stopNodes[n];
        typeof s == "string" && (s.startsWith("*.") ? this.stopNodesWildcard.add(s.substring(2)) : this.stopNodesExact.add(s));
      }
    }
  }
}
function De(e) {
  const t = Object.keys(e);
  for (let n = 0; n < t.length; n++) {
    const s = t[n], i = s.replace(/[.\-+*:]/g, "\\.");
    this.lastEntities[s] = {
      regex: new RegExp("&" + i + ";", "g"),
      val: e[s]
    };
  }
}
function et(e, t, n, s, i, r, l) {
  if (e !== void 0 && (this.options.trimValues && !s && (e = e.trim()), e.length > 0)) {
    l || (e = this.replaceEntitiesValue(e, t, n));
    const a = this.options.tagValueProcessor(t, e, n, i, r);
    return a == null ? e : typeof a != typeof e || a !== e ? a : this.options.trimValues ? X(e, this.options.parseTagValue, this.options.numberParseOptions) : e.trim() === e ? X(e, this.options.parseTagValue, this.options.numberParseOptions) : e;
  }
}
function tt(e) {
  if (this.options.removeNSPrefix) {
    const t = e.split(":"), n = e.charAt(0) === "/" ? "/" : "";
    if (t[0] === "xmlns")
      return "";
    t.length === 2 && (e = n + t[1]);
  }
  return e;
}
const nt = new RegExp(`([^\\s=]+)\\s*(=\\s*(['"])([\\s\\S]*?)\\3)?`, "gm");
function st(e, t, n) {
  if (this.options.ignoreAttributes !== !0 && typeof e == "string") {
    const s = le(e, nt), i = s.length, r = {};
    for (let l = 0; l < i; l++) {
      const a = this.resolveNameSpace(s[l][1]);
      if (this.ignoreAttributesFn(a, t))
        continue;
      let u = s[l][4], o = this.options.attributeNamePrefix + a;
      if (a.length)
        if (this.options.transformAttributeName && (o = this.options.transformAttributeName(o)), o === "__proto__" && (o = "#__proto__"), u !== void 0) {
          this.options.trimValues && (u = u.trim()), u = this.replaceEntitiesValue(u, n, t);
          const f = this.options.attributeValueProcessor(a, u, t);
          f == null ? r[o] = u : typeof f != typeof u || f !== u ? r[o] = f : r[o] = X(
            u,
            this.options.parseAttributeValue,
            this.options.numberParseOptions
          );
        } else
          this.options.allowBooleanAttributes && (r[o] = !0);
    }
    if (!Object.keys(r).length)
      return;
    if (this.options.attributesGroupName) {
      const l = {};
      return l[this.options.attributesGroupName] = r, l;
    }
    return r;
  }
}
const rt = function(e) {
  e = e.replace(/\r\n?/g, `
`);
  const t = new m("!xml");
  let n = t, s = "", i = "";
  this.entityExpansionCount = 0, this.currentExpandedLength = 0;
  const r = new Ue(this.options.processEntities);
  for (let l = 0; l < e.length; l++)
    if (e[l] === "<")
      if (e[l + 1] === "/") {
        const u = v(e, ">", l, "Closing Tag is not closed.");
        let o = e.substring(l + 2, u).trim();
        if (this.options.removeNSPrefix) {
          const h = o.indexOf(":");
          h !== -1 && (o = o.substr(h + 1));
        }
        this.options.transformTagName && (o = this.options.transformTagName(o)), n && (s = this.saveTextToParentTag(s, n, i));
        const f = i.substring(i.lastIndexOf(".") + 1);
        if (o && this.options.unpairedTags.indexOf(o) !== -1)
          throw new Error(`Unpaired tag can not be used as closing tag: </${o}>`);
        let c = 0;
        f && this.options.unpairedTags.indexOf(f) !== -1 ? (c = i.lastIndexOf(".", i.lastIndexOf(".") - 1), this.tagsNodeStack.pop()) : c = i.lastIndexOf("."), i = i.substring(0, c), n = this.tagsNodeStack.pop(), s = "", l = u;
      } else if (e[l + 1] === "?") {
        let u = B(e, l, !1, "?>");
        if (!u)
          throw new Error("Pi Tag is not closed.");
        if (s = this.saveTextToParentTag(s, n, i), !(this.options.ignoreDeclaration && u.tagName === "?xml" || this.options.ignorePiTags)) {
          const o = new m(u.tagName);
          o.add(this.options.textNodeName, ""), u.tagName !== u.tagExp && u.attrExpPresent && (o[":@"] = this.buildAttributesMap(u.tagExp, i, u.tagName)), this.addChild(n, o, i, l);
        }
        l = u.closeIndex + 1;
      } else if (e.substr(l + 1, 3) === "!--") {
        const u = v(e, "-->", l + 4, "Comment is not closed.");
        if (this.options.commentPropName) {
          const o = e.substring(l + 4, u - 2);
          s = this.saveTextToParentTag(s, n, i), n.add(this.options.commentPropName, [{ [this.options.textNodeName]: o }]);
        }
        l = u;
      } else if (e.substr(l + 1, 2) === "!D") {
        const u = r.readDocType(e, l);
        this.docTypeEntities = u.entities, l = u.i;
      } else if (e.substr(l + 1, 2) === "![") {
        const u = v(e, "]]>", l, "CDATA is not closed.") - 2, o = e.substring(l + 9, u);
        s = this.saveTextToParentTag(s, n, i);
        let f = this.parseTextData(o, n.tagname, i, !0, !1, !0, !0);
        f == null && (f = ""), this.options.cdataPropName ? n.add(this.options.cdataPropName, [{ [this.options.textNodeName]: o }]) : n.add(this.options.textNodeName, f), l = u + 2;
      } else {
        let u = B(e, l, this.options.removeNSPrefix), o = u.tagName;
        const f = u.rawTagName;
        let c = u.tagExp, h = u.attrExpPresent, N = u.closeIndex;
        if (this.options.transformTagName) {
          const g = this.options.transformTagName(o);
          c === o && (c = g), o = g;
        }
        if (this.options.strictReservedNames && (o === this.options.commentPropName || o === this.options.cdataPropName))
          throw new Error(`Invalid tag name: ${o}`);
        n && s && n.tagname !== "!xml" && (s = this.saveTextToParentTag(s, n, i, !1));
        const p = n;
        p && this.options.unpairedTags.indexOf(p.tagname) !== -1 && (n = this.tagsNodeStack.pop(), i = i.substring(0, i.lastIndexOf("."))), o !== t.tagname && (i += i ? "." + o : o);
        const y = l;
        if (this.isItStopNode(this.stopNodesExact, this.stopNodesWildcard, i, o)) {
          let g = "";
          if (c.length > 0 && c.lastIndexOf("/") === c.length - 1)
            o[o.length - 1] === "/" ? (o = o.substr(0, o.length - 1), i = i.substr(0, i.length - 1), c = o) : c = c.substr(0, c.length - 1), l = u.closeIndex;
          else if (this.options.unpairedTags.indexOf(o) !== -1)
            l = u.closeIndex;
          else {
            const _ = this.readStopNodeData(e, f, N + 1);
            if (!_)
              throw new Error(`Unexpected end of ${f}`);
            l = _.i, g = _.tagContent;
          }
          const O = new m(o);
          o !== c && h && (O[":@"] = this.buildAttributesMap(c, i, o)), g && (g = this.parseTextData(g, o, i, !0, h, !0, !0)), i = i.substr(0, i.lastIndexOf(".")), O.add(this.options.textNodeName, g), this.addChild(n, O, i, y);
        } else {
          if (c.length > 0 && c.lastIndexOf("/") === c.length - 1) {
            if (o[o.length - 1] === "/" ? (o = o.substr(0, o.length - 1), i = i.substr(0, i.length - 1), c = o) : c = c.substr(0, c.length - 1), this.options.transformTagName) {
              const O = this.options.transformTagName(o);
              c === o && (c = O), o = O;
            }
            const g = new m(o);
            o !== c && h && (g[":@"] = this.buildAttributesMap(c, i, o)), this.addChild(n, g, i, y), i = i.substr(0, i.lastIndexOf("."));
          } else if (this.options.unpairedTags.indexOf(o) !== -1) {
            const g = new m(o);
            o !== c && h && (g[":@"] = this.buildAttributesMap(c, i)), this.addChild(n, g, i, y), i = i.substr(0, i.lastIndexOf(".")), l = u.closeIndex;
            continue;
          } else {
            const g = new m(o);
            if (this.tagsNodeStack.length > this.options.maxNestedTags)
              throw new Error("Maximum nested tags exceeded");
            this.tagsNodeStack.push(n), o !== c && h && (g[":@"] = this.buildAttributesMap(c, i, o)), this.addChild(n, g, i, y), n = g;
          }
          s = "", l = N;
        }
      }
    else
      s += e[l];
  return t.child;
};
function it(e, t, n, s) {
  this.options.captureMetaData || (s = void 0);
  const i = this.options.updateTag(t.tagname, n, t[":@"]);
  i === !1 || (typeof i == "string" && (t.tagname = i), e.addChild(t, s));
}
const ot = function(e, t, n) {
  if (e.indexOf("&") === -1)
    return e;
  const s = this.options.processEntities;
  if (!s.enabled || s.allowedTags && !s.allowedTags.includes(t) || s.tagFilter && !s.tagFilter(t, n))
    return e;
  for (let i in this.docTypeEntities) {
    const r = this.docTypeEntities[i], l = e.match(r.regx);
    if (l) {
      if (this.entityExpansionCount += l.length, s.maxTotalExpansions && this.entityExpansionCount > s.maxTotalExpansions)
        throw new Error(
          `Entity expansion limit exceeded: ${this.entityExpansionCount} > ${s.maxTotalExpansions}`
        );
      const a = e.length;
      if (e = e.replace(r.regx, r.val), s.maxExpandedLength && (this.currentExpandedLength += e.length - a, this.currentExpandedLength > s.maxExpandedLength))
        throw new Error(
          `Total expanded content size exceeded: ${this.currentExpandedLength} > ${s.maxExpandedLength}`
        );
    }
  }
  if (e.indexOf("&") === -1)
    return e;
  for (let i in this.lastEntities) {
    const r = this.lastEntities[i];
    e = e.replace(r.regex, r.val);
  }
  if (e.indexOf("&") === -1)
    return e;
  if (this.options.htmlEntities)
    for (let i in this.htmlEntities) {
      const r = this.htmlEntities[i];
      e = e.replace(r.regex, r.val);
    }
  return e = e.replace(this.ampEntity.regex, this.ampEntity.val), e;
};
function lt(e, t, n, s) {
  return e && (s === void 0 && (s = t.child.length === 0), e = this.parseTextData(
    e,
    t.tagname,
    n,
    !1,
    t[":@"] ? Object.keys(t[":@"]).length !== 0 : !1,
    s
  ), e !== void 0 && e !== "" && t.add(this.options.textNodeName, e), e = ""), e;
}
function ut(e, t, n, s) {
  return !!(t && t.has(s) || e && e.has(n));
}
function at(e, t, n = ">") {
  let s, i = "";
  for (let r = t; r < e.length; r++) {
    let l = e[r];
    if (s)
      l === s && (s = "");
    else if (l === '"' || l === "'")
      s = l;
    else if (l === n[0])
      if (n[1]) {
        if (e[r + 1] === n[1])
          return {
            data: i,
            index: r
          };
      } else
        return {
          data: i,
          index: r
        };
    else
      l === "	" && (l = " ");
    i += l;
  }
}
function v(e, t, n, s) {
  const i = e.indexOf(t, n);
  if (i === -1)
    throw new Error(s);
  return i + t.length - 1;
}
function B(e, t, n, s = ">") {
  const i = at(e, t + 1, s);
  if (!i)
    return;
  let r = i.data;
  const l = i.index, a = r.search(/\s/);
  let u = r, o = !0;
  a !== -1 && (u = r.substring(0, a), r = r.substring(a + 1).trimStart());
  const f = u;
  if (n) {
    const c = u.indexOf(":");
    c !== -1 && (u = u.substr(c + 1), o = u !== i.data.substr(c + 1));
  }
  return {
    tagName: u,
    tagExp: r,
    closeIndex: l,
    attrExpPresent: o,
    rawTagName: f
  };
}
function ct(e, t, n) {
  const s = n;
  let i = 1;
  for (; n < e.length; n++)
    if (e[n] === "<")
      if (e[n + 1] === "/") {
        const r = v(e, ">", n, `${t} is not closed`);
        if (e.substring(n + 2, r).trim() === t && (i--, i === 0))
          return {
            tagContent: e.substring(s, n),
            i: r
          };
        n = r;
      } else if (e[n + 1] === "?")
        n = v(e, "?>", n + 1, "StopNode is not closed.");
      else if (e.substr(n + 1, 3) === "!--")
        n = v(e, "-->", n + 3, "StopNode is not closed.");
      else if (e.substr(n + 1, 2) === "![")
        n = v(e, "]]>", n, "StopNode is not closed.") - 2;
      else {
        const r = B(e, n, ">");
        r && ((r && r.tagName) === t && r.tagExp[r.tagExp.length - 1] !== "/" && i++, n = r.closeIndex);
      }
}
function X(e, t, n) {
  if (t && typeof e == "string") {
    const s = e.trim();
    return s === "true" ? !0 : s === "false" ? !1 : Ze(e, n);
  } else
    return Se(e) ? e : "";
}
function Q(e, t, n) {
  const s = Number.parseInt(e, t);
  return s >= 0 && s <= 1114111 ? String.fromCodePoint(s) : n + e + ";";
}
const j = m.getMetaDataSymbol();
function ft(e, t) {
  return ce(e, t);
}
function ce(e, t, n) {
  let s;
  const i = {};
  for (let r = 0; r < e.length; r++) {
    const l = e[r], a = dt(l);
    let u = "";
    if (n === void 0 ? u = a : u = n + "." + a, a === t.textNodeName)
      s === void 0 ? s = l[a] : s += "" + l[a];
    else {
      if (a === void 0)
        continue;
      if (l[a]) {
        let o = ce(l[a], t, u);
        const f = pt(o, t);
        l[":@"] ? ht(o, l[":@"], u, t) : Object.keys(o).length === 1 && o[t.textNodeName] !== void 0 && !t.alwaysCreateTextNode ? o = o[t.textNodeName] : Object.keys(o).length === 0 && (t.alwaysCreateTextNode ? o[t.textNodeName] = "" : o = ""), l[j] !== void 0 && typeof o == "object" && o !== null && (o[j] = l[j]), i[a] !== void 0 && Object.prototype.hasOwnProperty.call(i, a) ? (Array.isArray(i[a]) || (i[a] = [i[a]]), i[a].push(o)) : t.isArray(a, u, f) ? i[a] = [o] : i[a] = o;
      }
    }
  }
  return typeof s == "string" ? s.length > 0 && (i[t.textNodeName] = s) : s !== void 0 && (i[t.textNodeName] = s), i;
}
function dt(e) {
  const t = Object.keys(e);
  for (let n = 0; n < t.length; n++) {
    const s = t[n];
    if (s !== ":@")
      return s;
  }
}
function ht(e, t, n, s) {
  if (t) {
    const i = Object.keys(t), r = i.length;
    for (let l = 0; l < r; l++) {
      const a = i[l];
      s.isArray(a, n + "." + a, !0, !0) ? e[a] = [t[a]] : e[a] = t[a];
    }
  }
}
function pt(e, t) {
  const { textNodeName: n } = t, s = Object.keys(e).length;
  return !!(s === 0 || s === 1 && (e[n] || typeof e[n] == "boolean" || e[n] === 0));
}
class gt {
  constructor(t) {
    this.externalEntities = {}, this.options = Xe(t);
  }
  /**
   * Parse XML dats to JS object 
   * @param {string|Uint8Array} xmlData 
   * @param {boolean|Object} validationOption 
   */
  parse(t, n) {
    if (typeof t != "string" && t.toString)
      t = t.toString();
    else if (typeof t != "string")
      throw new Error("XML data is accepted in String or Bytes[] form.");
    if (n) {
      n === !0 && (n = {});
      const r = ue(t, n);
      if (r !== !0)
        throw Error(`${r.err.msg}:${r.err.line}:${r.err.col}`);
    }
    const s = new He(this.options);
    s.addExternalEntities(this.externalEntities);
    const i = s.parseXml(t);
    return this.options.preserveOrder || i === void 0 ? i : ft(i, this.options);
  }
  /**
   * Add Entity which is not by default supported by this library
   * @param {string} key 
   * @param {string} value 
   */
  addEntity(t, n) {
    if (n.indexOf("&") !== -1)
      throw new Error("Entity value can't have '&'");
    if (t.indexOf("&") !== -1 || t.indexOf(";") !== -1)
      throw new Error("An entity must be set without '&' and ';'. Eg. use '#xD' for '&#xD;'");
    if (n === "&")
      throw new Error("An entity with value '&' is not permitted");
    this.externalEntities[t] = n;
  }
  /**
   * Returns a Symbol that can be used to access the metadata
   * property on a node.
   * 
   * If Symbol is not available in the environment, an ordinary property is used
   * and the name of the property is here returned.
   * 
   * The XMLMetaData property is only present when `captureMetaData`
   * is true in the options.
   */
  static getMetaDataSymbol() {
    return m.getMetaDataSymbol();
  }
}
const Et = {
  validate: ue
}, bt = new gt({
  preserveOrder: !0,
  ignoreAttributes: !1,
  attributeNamePrefix: "",
  allowBooleanAttributes: !0,
  commentPropName: U,
  cdataPropName: Y,
  parseTagValue: !1
});
function Tt(e) {
  return V(() => {
    try {
      if (!Et.validate(e))
        throw new Error("Invalid XML!");
      const t = bt.parse(e);
      if (typeof e == "string" && e.trim().length > 0 && t.length === 0)
        throw new Error("Invalid XML!");
      return { json: t, valid: !0 };
    } catch (t) {
      return { json: null, valid: !1, errorMessage: `Fail to parse: ${t.message}` };
    }
  }, [e]);
}
function C(e, t = !0) {
  const { push: n } = se(), s = ee(null);
  return $(() => {
    t && s.current && e && n(e, { element: s.current });
  }, [s.current, n, e, t]), s;
}
function Nt(e) {
  const { indentation: t, children: n, isInline: s, keyValue: i } = e, { theme: r } = w(), l = C(i), a = C(`${i}-close`, !s);
  return /* @__PURE__ */ I("div", { style: { color: r.cdataColor }, children: [
    /* @__PURE__ */ d("span", { ref: l, children: `${t}<![CDATA[` }),
    n,
    /* @__PURE__ */ d("span", { ref: a, children: `${s ? "" : t}]]>` })
  ] });
}
const yt = (e) => /* @__PURE__ */ z.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ z.createElement("path", { d: "M9 17.898C9 18.972 10.2649 19.546 11.0731 18.8388L17.3838 13.3169C18.1806 12.6197 18.1806 11.3801 17.3838 10.6829L11.0731 5.16108C10.2649 4.45388 9 5.02785 9 6.1018V17.898Z" }));
function fe(e) {
  const { collapsible: t, theme: n } = w(), { collapsed: s } = e;
  return t ? /* @__PURE__ */ d("span", { style: { position: "relative" }, children: /* @__PURE__ */ d("span", { style: { position: "absolute", right: "0", border: 0, padding: 0, background: "none" }, children: /* @__PURE__ */ d(
    yt,
    {
      fill: n.separatorColor,
      style: { transform: `rotate(${s ? 0 : 90}deg)`, transition: "transform 0.2s" }
    }
  ) }) }) : null;
}
function de(e) {
  const { collapsible: t, initialCollapsedDepth: n } = w(), s = n != null, [i, r] = S(
    () => !s || !t ? !1 : e >= n
  ), l = () => r((a) => !a);
  return $(() => {
    r(
      !s || !t ? !1 : e >= n
    );
  }, [n, e, t]), {
    collapsed: i,
    buttonProps: t ? {
      onClick: l,
      role: "button",
      style: { cursor: "pointer" }
    } : {}
  };
}
function wt(e) {
  const { indentation: t, children: n, isInline: s, level: i, keyValue: r } = e, { theme: l } = w(), { collapsed: a, buttonProps: u } = de(i), o = C(r), f = C(`${r}-close`, !s), c = a ? "none" : void 0;
  return /* @__PURE__ */ I("div", { style: { color: l.commentColor }, children: [
    /* @__PURE__ */ I("span", { ...u, children: [
      /* @__PURE__ */ d("span", { children: t }),
      /* @__PURE__ */ d(fe, { collapsed: a }),
      /* @__PURE__ */ d("span", { ref: o, children: "<!-- " })
    ] }),
    /* @__PURE__ */ d("span", { style: { display: c }, children: n }),
    a && "...",
    /* @__PURE__ */ d("span", { style: { display: c }, ref: f, children: `${s || a ? " " : t}-->` })
  ] });
}
function he(e) {
  const { attributes: t } = e, { theme: n } = w();
  return t ? /* @__PURE__ */ d("span", { children: Object.entries(t).map(([s, i]) => /* @__PURE__ */ I("span", { children: [
    /* @__PURE__ */ d("span", { style: { color: n.attributeKeyColor }, children: ` ${s}` }),
    /* @__PURE__ */ d("span", { style: { color: n.separatorColor }, children: "=" }),
    /* @__PURE__ */ d("span", { style: { color: n.attributeValueColor }, children: `"${i}"` })
  ] }, `attribute-${s}`)) }) : null;
}
function It(e) {
  const { indentation: t, tagKey: n, attributes: s, keyValue: i } = e, { theme: r } = w(), l = C(i);
  return /* @__PURE__ */ I("div", { ref: l, children: [
    /* @__PURE__ */ d("span", { style: { color: r.separatorColor }, children: `${t}<?` }),
    /* @__PURE__ */ d("span", { style: { color: r.tagColor }, children: `${n.slice(1)}` }),
    /* @__PURE__ */ d(he, { attributes: s }),
    /* @__PURE__ */ d("span", { style: { color: r.separatorColor }, children: "?>" })
  ] });
}
function mt(e) {
  const { indentation: t, tagKey: n, attributes: s, children: i, isInline: r, hasChildren: l, level: a, keyValue: u } = e, { collapsed: o, buttonProps: f } = de(a), { theme: c } = w(), h = C(u), N = C(`${u}-close`, !r), p = o ? "none" : void 0;
  return /* @__PURE__ */ I("div", { ref: h, children: [
    /* @__PURE__ */ I("span", { ...f, children: [
      /* @__PURE__ */ d("span", { children: t }),
      /* @__PURE__ */ d(fe, { collapsed: o }),
      /* @__PURE__ */ d("span", { style: { color: c.separatorColor }, children: "<" }),
      /* @__PURE__ */ d("span", { style: { color: c.tagColor }, children: `${n}` }),
      !o && /* @__PURE__ */ d(he, { attributes: s }),
      !o && /* @__PURE__ */ d("span", { style: { color: c.separatorColor }, children: l ? ">" : " />" })
    ] }),
    l && /* @__PURE__ */ I(J, { children: [
      /* @__PURE__ */ d("span", { style: { display: p }, children: i }),
      o && /* @__PURE__ */ d("span", { style: { color: "#777" }, children: "..." }),
      /* @__PURE__ */ d("span", { style: { color: c.separatorColor, display: p }, children: `${r || o ? "" : t}</` }),
      /* @__PURE__ */ d("span", { style: { color: c.tagColor, display: p }, children: `${n}` }),
      /* @__PURE__ */ d("span", { style: { color: c.separatorColor, display: p }, ref: N, children: ">" })
    ] })
  ] });
}
function Ct(e) {
  const { children: t, keyValue: n } = e, s = C(n);
  return /* @__PURE__ */ d("div", { ref: s, children: t });
}
function At(e) {
  const { hasSiblings: t, text: n, indentation: s, isText: i, keyValue: r } = e, { theme: l } = w(), a = i ? { color: l.textColor } : void 0;
  return ie(n) || t ? /* @__PURE__ */ d("div", { style: a, children: n.split(`
`).filter((u) => !!u.trim()).map((u, o) => /* @__PURE__ */ d(
    Ct,
    {
      keyValue: `${r}${o}`,
      children: `${s}${u.trim()}`
    },
    `${r}${o}`
  )) }) : /* @__PURE__ */ d("span", { style: a, children: n });
}
function L(e) {
  const { elements: t, level: n = 0, isText: s = !0, parentKey: i = "" } = e, { indentSize: r } = w();
  return !Array.isArray(t) || t.length === 0 ? null : /* @__PURE__ */ d(J, { children: t.map((l, a) => {
    const { tagKey: u, attributes: o, subElements: f, type: c } = Ae(l), h = t.length > 1, N = we(r, n), p = `${i}-${n + 1}-${a + 1}`, y = Ie(f);
    switch (c) {
      case k:
        return /* @__PURE__ */ d(
          At,
          {
            text: f,
            indentation: N,
            hasSiblings: h,
            isText: s,
            keyValue: p
          },
          p
        );
      case U:
        return /* @__PURE__ */ d(
          wt,
          {
            keyValue: p,
            isInline: y,
            indentation: N,
            level: n,
            children: /* @__PURE__ */ d(
              L,
              {
                elements: f,
                level: n + 1,
                parentKey: p,
                isText: !1
              }
            )
          },
          p
        );
      case Y:
        return /* @__PURE__ */ d(Nt, { keyValue: p, indentation: N, isInline: y, children: /* @__PURE__ */ d(
          L,
          {
            elements: f,
            level: n + 1,
            parentKey: p,
            isText: !1
          }
        ) }, p);
      case te:
        return /* @__PURE__ */ d(
          It,
          {
            indentation: N,
            tagKey: u,
            attributes: o,
            keyValue: p
          },
          p
        );
      default:
        return /* @__PURE__ */ d(
          mt,
          {
            indentation: N,
            tagKey: u,
            attributes: o,
            isInline: y,
            hasChildren: f.length > 0,
            level: n,
            keyValue: p,
            children: /* @__PURE__ */ d(L, { elements: f, level: n + 1, parentKey: p })
          },
          p
        );
    }
  }) });
}
function vt() {
  return /* @__PURE__ */ d("div", { children: "Invalid XML!" });
}
function pe(e) {
  return e ? e.checkVisibility ? e.checkVisibility() : !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length) : !1;
}
function ge(e) {
  return !e || !e.parentElement ? 0 : pe(e.parentElement) ? e.parentElement.offsetTop : ge(e.parentElement);
}
function Ot({ viewerContainer: e }) {
  const { lines: t } = se(), { theme: n } = w(), [s, i] = S({ width: 0, height: 0 }), r = ee(null), { sortedLines: l, numberOfLines: a } = V(() => {
    const o = Object.values(t).map((f) => {
      var h;
      const c = pe(f.element);
      return {
        ...f,
        offset: c ? (h = f.element) == null ? void 0 : h.offsetTop : ge(f.element),
        visible: c
      };
    }).sort((f, c) => f.offset === c.offset ? f.visible === c.visible ? 0 : f.visible ? -1 : 1 : f.offset - c.offset).map((f, c) => ({
      ...f,
      lineNumber: c + 1
    }));
    return {
      sortedLines: o.filter((f) => f.visible),
      numberOfLines: o.length + 1
    };
  }, [t, s.width, s.height]), u = V(() => new ResizeObserver(function(o) {
    const { width: f, height: c } = o[0].contentRect;
    i({ width: f, height: c });
  }), []);
  return $(() => {
    e && u.observe(e);
  }, [e, u]), $(() => () => {
    u.disconnect();
  }, []), /* @__PURE__ */ d(
    "div",
    {
      ref: r,
      style: {
        width: 16 + 8 * String(a).length,
        height: "auto",
        backgroundColor: n.lineNumberBackground,
        color: n.lineNumberColor,
        marginRight: 16,
        paddingTop: 8,
        position: "relative"
      },
      children: l.map((o) => {
        var f;
        return /* @__PURE__ */ d(
          "div",
          {
            style: {
              position: "absolute",
              top: o.offset - (((f = r.current) == null ? void 0 : f.offsetTop) ?? 0),
              right: 8
            },
            children: o.lineNumber
          },
          o.lineNumber
        );
      })
    }
  );
}
function St(e) {
  const {
    theme: t,
    xml: n,
    collapsible: s = !1,
    indentSize: i = 2,
    invalidXml: r,
    initialCollapsedDepth: l,
    showLineNumbers: a = !1
  } = e, [u, o] = S(() => ({ ...M, ...t })), { json: f, valid: c } = Tt(n), [h, N] = S(null), p = V(
    () => ({
      theme: u,
      collapsible: s,
      indentSize: i,
      initialCollapsedDepth: l
    }),
    [u, s, i, l]
  );
  return $(() => {
    o((y) => {
      const g = { ...M, ...t };
      return ve(g, y) ? y : g;
    });
  }, [t]), c ? /* @__PURE__ */ d(re.Provider, { value: p, children: /* @__PURE__ */ d(Ne, { children: /* @__PURE__ */ I(
    "div",
    {
      className: "rxv-container",
      style: {
        fontFamily: u.fontFamily,
        display: "flex",
        flexDirection: "row"
      },
      children: [
        a && /* @__PURE__ */ d(Ot, { viewerContainer: h }),
        /* @__PURE__ */ d(
          "div",
          {
            ref: N,
            style: {
              flex: 1,
              whiteSpace: "pre-wrap",
              overflowWrap: "break-word",
              overflow: "auto",
              paddingTop: 4,
              paddingBottom: 4,
              paddingLeft: s ? 10 : 0
            },
            children: /* @__PURE__ */ d(L, { elements: f })
          }
        )
      ]
    }
  ) }, n) }) : r || /* @__PURE__ */ d(vt, {});
}
export {
  St as default
};
//# sourceMappingURL=index.es.js.map
